// src/app/store/embeddings/embedding.reducer.ts
import {createReducer, on} from '@ngrx/store';
import * as EmbeddingActions from './embedding.actions';
import {
  EmbeddingAugmentorResultDTO,
  EmbeddingDTO,
  PaperHasEmbeddingDTO,
  ProjectHasEmbeddingOverviewDTO
} from '../dto/embedding';

export interface EmbeddingState {
  projectEmbeddings: { [projectId: number]: EmbeddingDTO[] };
  projectEmbeddingsOverview: { [projectId: number]: ProjectHasEmbeddingOverviewDTO };
  paperHasEmbeddings: { [projectId: number]: PaperHasEmbeddingDTO[] };
  paperEmbeddings: EmbeddingDTO[];
  embeddingAugmentorResults: EmbeddingAugmentorResultDTO[];
  checkPaperHasEmbeddings: { [paperId: number]: boolean | undefined };
  loading: boolean;
  error: any;
}

export const initialEmbeddingState: EmbeddingState = {
  projectEmbeddings: {},
  paperHasEmbeddings: {},
  projectEmbeddingsOverview: {},
  checkPaperHasEmbeddings: {},
  paperEmbeddings: [],
  embeddingAugmentorResults: [],
  loading: false,
  error: null,
};

export const embeddingReducer = createReducer(
  initialEmbeddingState,

  // getAllEmbeddingsForProject
  on(EmbeddingActions.loadEmbeddingsForProject, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(EmbeddingActions.loadEmbeddingsForProjectSuccess, (state, {embeddings, projectId}) => ({
    ...state,
    projectEmbeddings: {
      ...state.projectEmbeddings,
      [projectId]: embeddings
    },
    loading: false
  })),
  on(EmbeddingActions.loadEmbeddingsForProjectFailure, (state, {error}) => ({
    ...state,
    error,
    loading: false
  })),
// deleteEmbeddingsForPaper
  on(EmbeddingActions.deleteEmbeddingsForUser, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(EmbeddingActions.deleteEmbeddingsForUserSuccess, (state, {}) => (initialEmbeddingState)),
  on(EmbeddingActions.deleteEmbeddingsForUserFailure, (state, {error}) => ({
    ...state,
    error,
    loading: false
  })),
  // projectHasEmbeddingOverview
  on(EmbeddingActions.loadProjectHasEmbeddingOverview, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(EmbeddingActions.loadProjectHasEmbeddingOverviewSuccess, (state, {result, projectId}) => ({
    ...state,
    projectEmbeddingsOverview: {
      ...state.projectEmbeddingsOverview,
      [projectId]: result
    },
    loading: false
  })),
  on(EmbeddingActions.loadProjectHasEmbeddingOverviewFailure, (state, {error}) => ({
    ...state,
    error,
    loading: false
  })),

  // hasAllPaperEmbedding
  on(EmbeddingActions.loadHasAllPaperEmbedding, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(EmbeddingActions.loadHasAllPaperEmbeddingSuccess, (state, {paperHasEmbeddings, projectId}) => ({
    ...state,
    paperHasEmbeddings: {
      ...state.paperHasEmbeddings,
      [projectId]: paperHasEmbeddings
    },
    loading: false
  })),
  on(EmbeddingActions.loadHasAllPaperEmbeddingFailure, (state, {error}) => ({
    ...state,
    error,
    loading: false
  })),

  // getAllEmbeddingsForPaper
  on(EmbeddingActions.loadEmbeddingsForPaper, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(EmbeddingActions.loadEmbeddingsForPaperSuccess, (state, {embeddings, paperId}) => {
    const updatedEmbeddings = state.paperEmbeddings.filter(embedding => embedding.paperId !== paperId);
    updatedEmbeddings.push(...embeddings);

    return {
      ...state,
      paperEmbeddings: updatedEmbeddings,
      loading: false
    };
  }),
  on(EmbeddingActions.loadEmbeddingsForPaperFailure, (state, {error}) => ({
    ...state,
    error,
    loading: false
  })),
  on(EmbeddingActions.loadEmbeddingAugmentorResult, state => ({
    ...state,
    loading: true,
    embeddingAugmentorResults: [],
    error: null
  })),
  on(EmbeddingActions.loadEmbeddingAugmentorResultSuccess, (state, {results}) => ({
    ...state,
    embeddingAugmentorResults: results,
    loading: false
  })),
  on(EmbeddingActions.loadEmbeddingAugmentorResultFailure, (state, {error}) => ({
    ...state,
    error,
    loading: false
  })),
  // Check and create
  on(EmbeddingActions.checkAndCreatePaperEmbedding, (state, {paperId}) => ({
    ...state,
    loading: true,
    checkPaperHasEmbeddings: {
      ...state.checkPaperHasEmbeddings,
      [paperId]: undefined
    },
    error: null
  })),
  on(EmbeddingActions.checkAndCreatePaperEmbeddingSuccess, (state, {hasEmbedding, paperId}) => ({
    ...state,
    checkPaperHasEmbeddings: {
      ...state.checkPaperHasEmbeddings,
      [paperId]: hasEmbedding
    },
    hasEmbedding,
    loading: false,
    error: null
  })),
  on(EmbeddingActions.checkAndCreatePaperEmbeddingFailure, (state, {error, paperId}) => ({
    ...state,
    checkPaperHasEmbeddings: {
      ...state.checkPaperHasEmbeddings,
      [paperId]: false
    },
    loading: false,
    error
  }))
);
